import { DateTime } from 'luxon'

export function formatIsoDateStringForPaymentSchedule(
  isoDateString: string,
  onInvalid: () => void,
) {
  const processDateTime = DateTime.max(
    DateTime.fromISO(isoDateString),
    // the earliest the user can schedule a payment for is "today" (they can't select a time more precisely than days)
    // but to be safe, let's set the (minimum) time to the latest second (which is the precision requried by the backend) while still being considered "today"
    DateTime.now().set({ hour: 23, minute: 59, second: 59 }),
  )
    .set({ millisecond: 0 })
    .toISO({ suppressMilliseconds: true })

  if (!processDateTime) {
    onInvalid()
    throw new Error(`Invalid payment date`, { cause: isoDateString })
  }

  return processDateTime
}
